import { render, staticRenderFns } from "./product-shelfup.vue?vue&type=template&id=67a45014&"
import script from "./product-shelfup.vue?vue&type=script&lang=ts&"
export * from "./product-shelfup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports